import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const C = { void2: '#060D4A', cyan: '#00FFFF', muted: 'rgba(248,249,250,0.72)', border: 'rgba(0,255,255,0.12)', magma: '#FF5722' };

const GTM_ID = process.env.REACT_APP_GTM_ID;

function loadGTM() {
  if (!GTM_ID || document.getElementById('scq-gtm')) return;
  // dataLayer initialisation
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  // Script tag
  const s = document.createElement('script');
  s.id = 'scq-gtm';
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(s);
  // noscript iframe fallback
  const ns = document.createElement('noscript');
  ns.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(ns, document.body.firstChild);
}

export function loadAnalyticsIfConsented() {
  try {
    const stored = localStorage.getItem('scq_cookie_consent');
    if (!stored) return;
    const { analytics } = JSON.parse(stored);
    if (analytics) {
      loadGTM();
    }
  } catch {}
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('scq_cookie_consent');
    if (!stored) {
      setVisible(true);
    } else {
      loadAnalyticsIfConsented();
    }
  }, []);

  function accept() {
    localStorage.setItem('scq_cookie_consent', JSON.stringify({ analytics: true, timestamp: new Date().toISOString() }));
    loadGTM();
    setVisible(false);
  }

  function reject() {
    localStorage.setItem('scq_cookie_consent', JSON.stringify({ analytics: false, timestamp: new Date().toISOString() }));
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={s.bar} role="dialog" aria-label="Cookie consent">
      <div style={s.inner}>
        <p style={s.text}>
          We use cookies to keep you signed in and, with your consent, to improve the site with Google Analytics and Microsoft Clarity.{' '}
          <Link to="/cookies" style={s.link}>Cookie policy</Link>
        </p>
        <div style={s.actions}>
          <button style={s.rejectBtn} onClick={reject}>Reject non-essential</button>
          <button style={s.acceptBtn} onClick={accept}>Accept all</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  bar: { position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000, background: C.void2, borderTop: `1px solid ${C.border}`, backdropFilter: 'blur(12px)', padding: '16px 24px' },
  inner: { maxWidth: 1100, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap' },
  text: { fontSize: 13, color: C.muted, margin: 0, lineHeight: 1.6, flex: 1, minWidth: 260 },
  link: { color: C.cyan, textDecoration: 'none' },
  actions: { display: 'flex', gap: 10, flexShrink: 0 },
  rejectBtn: { padding: '9px 16px', background: 'transparent', color: C.muted, border: `1px solid rgba(248,249,250,0.15)`, borderRadius: 8, fontSize: 13, fontFamily: "'Satoshi','Inter',sans-serif", fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' },
  acceptBtn: { padding: '9px 18px', background: C.magma, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontFamily: "'Satoshi','Inter',sans-serif", fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' },
};
